import React from 'react';
import styled from 'styled-components/macro';
import * as colors from './colorConstants';

export const ToggleSwitch = styled.input.attrs({ type: 'checkbox' })`
  width: 24px;
  height: 12px;
  border-radius: 10px;
  appearance: none;
  border: 1px solid;
  border-color: ${colors.lightGray1};
  background: ${colors.white};
  position: relative;
  outline: none !important;
  transition: background 0.15s linear;
  cursor: pointer;

  :before {
    content: '';
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: ${colors.lightGray1};
    position: absolute;
    left: 0;
    bottom: 50%;
    transform: translateY(50%);
    transition: transform 0.15s linear;
  }

  :checked {
    border-color: ${colors.simplrBlue};
    background: ${colors.simplrBlue};
    :before {
      transform: translate(100%, 50%);
    }
  }
`;

export const FadeText = styled.div`
  margin: 0px;
  padding: 0px;
  animation-name: fadeIn;
  animation-duration: 0.8s;
  animation-fill-mode: forwards;

  @keyframes fadeIn {
    0% {
      opacity: 0%;
    }
    100% {
      opacity: 100%;
    }
  }
`;

export const SwitchWithLabel = (props) => {
  return (
    <ToggleWrapper onClick={props.onClick} active={props.active}>
      <ToggleLabel active={props.active}>{props.label}</ToggleLabel>
      <ToggleBall active={props.active} />
    </ToggleWrapper>
  );
};

const ToggleWrapper = styled.div`
  background: ${(props) => (props.active ? colors.simplrBlue : colors.lightGray36)};
  padding: ${(props) => (props.active ? '6px 30px 6px 11px' : '6px 11px 6px 30px')};
  border-radius: 17px;
  position: relative;
  width: 90px;
  cursor: pointer;
`;

const ToggleLabel = styled.div`
  font-size: 11px;
  line-height: 12px;
  color: ${(props) => (props.active ? colors.white + '60' : colors.lightGray9)};
  width: 100%;
  text-align: center;
`;

const ToggleBall = styled.div`
  height: 19px;
  width: 19px;
  border-radius: 50%;
  background: ${(props) => (props.active ? colors.white : colors.lightGray35)};
  position: absolute;
  top: 50%;
  right: ${(props) => (props.active ? '3px' : 'calc(100% - 22px)')};
  transform: translateY(-50%);
  transition: 0.3s all linear;
`;
